// removed by extract-text-webpack-plugin
module.exports = {"app":"index__app___IEf3n"};


//////////////////
// WEBPACK FOOTER
// ./src/index.scss
// module id = ./src/index.scss
// module chunks = 1